let obj = {
  statusData: [
    { label: '禁用', value: 0 },
    { label: '启用', value: 1 },
  ],
  typeData: [
    { label: '停放区围栏', value: 0 },
    { label: '工作区围栏', value: 1 },
  ],
  gfTypeData: [
    { label: '禁行区围栏', value: 0 },
    // { label: '企业网点考勤围栏', value: 1 },
    { label: '工作区围栏', value: 2 },
    { label: '停车区围栏', value: 3 },
  ],
  // 0：禁行区围栏，1：企业网点考勤围栏，2：工作区围栏，3：停车区围栏
  alarmTypeData: [
    { label: '入围栏报警', value: 0 },
    { label: '出围栏报警', value: 1 },
  ],
  // -1，无，0：进报警，1：出报警，2：进出报警
}
export default obj
